import React from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import DeprecatedRawCheckbox from './DeprecatedRawCheckbox';
import s from './DeprecatedCheckbox.scss';

/*
 * redux-form has an issue where onBlur is called and all the input values are lost
 * see this issue for more information https://github.com/erikras/redux-form/issues/2768
 */

export type DeprecatedCheckboxProps = {
  containerClassName?: string;
  labelClassName?: string;
  inputClassName?: string;
  loaderClassName?: string;
  checkedRectClassName?: string;
  uncheckedRectClassName?: string;
  onForm?: boolean;
  isDisabled?: boolean;
  isChecked?: boolean;
  isRequired?: boolean;
  label?: string;
  name?: string;
  onClick?: (
    ev: React.MouseEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>
  ) => Promise<void> | void;
  waitForOnClick?: boolean;
};

export type DeprecatedCheckboxReduxFormProps = DeprecatedCheckboxProps &
  InjectedFormProps<DeprecatedCheckboxProps> &
  React.HTMLAttributes<HTMLInputElement>;

/** @deprecated use Checkbox instead */
export default class DeprecatedCheckbox extends React.Component<DeprecatedCheckboxReduxFormProps> {
  public static readonly displayName = 'DeprecatedCheckbox';

  static handleOnBlur(e: React.FocusEvent<HTMLInputElement>) {
    e.preventDefault();
  }

  render() {
    const {
      containerClassName,
      onForm = true,
      ...passThroughProps
    } = this.props;

    const containerClassNames = [
      'input__checkbox',
      s.container,
      containerClassName,
    ].join(' ');
    return (
      <div className={containerClassNames}>
        {onForm ? (
          <Field
            name="checkbox"
            type="checkbox"
            onBlur={DeprecatedCheckbox.handleOnBlur}
            component={DeprecatedRawCheckbox}
            isChecked={passThroughProps.isChecked}
            {...passThroughProps}
          />
        ) : (
          <DeprecatedRawCheckbox {...passThroughProps} />
        )}
      </div>
    );
  }
}

reduxForm<DeprecatedCheckboxProps>({
  form: 'checkbox',
})(DeprecatedCheckbox);
